<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "platformHome"
}
</script>

<style scoped>

</style>
